import { STEP_IDS, STEPS } from './inscricaoSections';

/*
 * Período de inscrição na edição pública (inscrito já gravado), em funções
 * puras sobre a resposta da identificação. É a regra do back
 * (ModoAtualizacaoPublica e PeriodoInscricao): dentro do período de
 * inscrição, todas as etapas; fora dele — ou sem calendário de inscrição, que
 * chega do mesmo jeito, `inscricaoAberta` falso —, só Documentos, e só com um
 * calendário de entrega aberto. Flag ausente (resposta antiga) é tratada como
 * período aberto.
 */

/* Índice da etapa Documentos no formulário (a posição dela em STEPS). */
export const ETAPA_DOCUMENTOS = STEPS.findIndex(etapa => etapa.id === STEP_IDS.DOCUMENTOS);

export const AVISO_INSCRICAO_COM_ENTREGA = 'O período de inscrição não está aberto: a ficha fica disponível só para consulta, e os documentos podem ser enviados conforme os prazos de entrega.';
export const AVISO_INSCRICAO_SEM_ENTREGA = 'O período de inscrição não está aberto: a ficha fica disponível só para consulta, sem alterações.';
export const AVISO_ALTERACOES_DESCARTADAS = 'O período de inscrição terminou antes de salvar: as alterações desta etapa não foram gravadas.';

/* Nenhum calendário de inscrição vigente no dia, ou nenhum cadastrado. */
export const periodoInscricaoFechado = (identificacao) => identificacao?.inscricaoAberta === false;

/* Entrega de documentos (calendário tipo 1) ou de documentos pendentes (tipo 2) aberta. */
export const entregaDocumentosAberta = (identificacao) =>
    Boolean(identificacao?.permitirEntregaDocumentos || identificacao?.permitirEntregaDocumentoPendentes);

/* A etapa abre só para consulta: nada dela pode ser salvo. */
export const etapaSomenteConsulta = (etapa, identificacao) =>
    periodoInscricaoFechado(identificacao)
    && !(etapa === ETAPA_DOCUMENTOS && entregaDocumentosAberta(identificacao));

/* Aviso da tela da inscrição (o único lugar com o aviso do período); nulo dentro do período. */
export const avisoPeriodoInscricao = (identificacao) => {
    if (!periodoInscricaoFechado(identificacao)) {
        return null;
    }

    return entregaDocumentosAberta(identificacao) ? AVISO_INSCRICAO_COM_ENTREGA : AVISO_INSCRICAO_SEM_ENTREGA;
};

/*
 * O período de inscrição fechou entre abrir a etapa e salvar: fora dele o
 * back grava só os documentos e ignora o resto do payload, sem erro. A
 * resposta do atualizar traz `inscricaoAberta` calculado no mesmo instante da
 * gravação. A resposta parcial não conta: nela a flag pode vir falsa só por
 * não ter sido possível calculá-la.
 */
export const alteracoesDescartadasPeloPeriodo = (resposta, etapa) =>
    resposta?.parcial !== true
    && periodoInscricaoFechado(resposta)
    && etapa !== ETAPA_DOCUMENTOS;
